// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
  height: 100%;
}

.quick-action-card {
  height: 100%;
}

.quick-action-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
}

.quick-action-icon {
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--ion-color-medium);
}

.quick-action-icon > * {
  width: 22px;
  height: 22px;
  font-size: 22px;
}

.quick-action-label {
  display: block;
  line-height: 1.15;
}

@media (max-width: 767px) {
  .quick-action-card {
    min-height: 72px;
  }
  .quick-action-content {
    height: 100%;
  }
  .quick-action-label {
    min-height: 2.3em;
    text-wrap: balance;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/dashboard-home/dashboard-quick-action.component.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,YAAA;AACF;;AAEA;EACE,YAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;AACF;;AAKA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,8BAAA;AAFF;;AAKA;EACE,WAAA;EACA,YAAA;EACA,eAAA;AAFF;;AAKA;EACE,cAAA;EACA,iBAAA;AAFF;;AAKA;EACE;IACE,gBAAA;EAFF;EAKA;IACE,YAAA;EAHF;EAMA;IACE,iBAAA;IACA,kBAAA;EAJF;AACF","sourcesContent":[":host {\n  display: block;\n  height: 100%;\n}\n\n.quick-action-card {\n  height: 100%;\n}\n\n.quick-action-content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n}\n\n// Normalizza tutte le icone (svg inline o ion-icon, dimensioni/box-model diversi tra loro)\n// dentro un contenitore fisso: senza questo, su desktop le tile con svg inline e quelle con\n// ion-icon renderizzavano ad altezze leggermente diverse e la griglia appariva disallineata.\n.quick-action-icon {\n  width: 24px;\n  height: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--ion-color-medium);\n}\n\n.quick-action-icon > * {\n  width: 22px;\n  height: 22px;\n  font-size: 22px;\n}\n\n.quick-action-label {\n  display: block;\n  line-height: 1.15;\n}\n\n@media (max-width: 767px) {\n  .quick-action-card {\n    min-height: 72px;\n  }\n\n  .quick-action-content {\n    height: 100%;\n  }\n\n  .quick-action-label {\n    min-height: 2.3em;\n    text-wrap: balance;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
